/* eslint-disable class-methods-use-this */
import Model from './Model';

export default class Sector extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'sectors';
    }
}
